import React from 'react';

import Message from 'components/Message';

import messages from './MaximizesRevenuePanel.messages';
import SmartRateTopicPanelLayout from './SmartRateTopicPanelLayout';

const MaximizesRevenuePanel = () => (
  <SmartRateTopicPanelLayout
    summaryBody={
      <>
        <Message as="p" message={messages.summaryBodyParagraph1} />
        <Message as="p" message={messages.summaryBodyParagraph2} />
      </>
    }
    summaryHeading={messages.summaryHeading}
  />
);

export default MaximizesRevenuePanel;
